<div class="kaart">
    @let k = this.kaart();
    @if (k != undefined) {
    <div class="kaart-label">{{k.type.label}}({{k.number}}) <button kendoButton (click)="this.onDelete()" [svgIcon]="icon" [size]="'small'"></button>
    </div>
    @if (k.type.maxDipSwitchBits != undefined) {
        <dip-switch [value]="k.dipSwitch" [bits]="k.type.maxDipSwitchBits" (valueChanged)="onDipChange($event)" [readOnly]="!this.editDipSwitch()"></dip-switch>

    }
    <ioview [ios]="k.getIOs()"></ioview>

    }
</div>